<template>
    <div class="container">
        <div class="handle-box-search">
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="司机姓名" prop="driver_name" min-width="100"> </el-table-column>
            <el-table-column label="司机手机号" prop="driver_phone" min-width="100"> </el-table-column>
            <el-table-column label="金额" prop="amount" min-width="100"> </el-table-column>
            <el-table-column label="数据" prop="amount" min-width="100"><template slot-scope="scope">
                    {{ JSON.parse(scope.row.sync) }}
                </template> </el-table-column>
            
            <el-table-column label="记录生成时间" prop="created_at" min-width="100"></el-table-column>
            <el-table-column label="状态" prop="status" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'">
                        {{scope.row.status =='1' ? '已处理' : '未处理'}}
                    </el-tag>
                </template>
                
                 </el-table-column>
            <el-table-column label="描述" prop="description" min-width="100"> </el-table-column>

            <el-table-column label="操作" width="270" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.status=='0'">
                        <el-button type="primary" trigger="click" @click="cutWallet(scope.row.wallet_fail_code)"> 重新扣款 </el-button>
                    <el-button type="primary" trigger="click" @click="cancelCutWallet(scope.row.wallet_fail_code)"> 不扣 </el-button>
                    </div>
                    
                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
var _this;

export default {
    data() {
        return {
           
            wallet_fail_code: {wallet_fail_code: ''},
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10
            },
            // 存放表格数据
            tableData: [],
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
      
        _this.searchFailLists();
    },

    methods: {
        cutWallet(val) {
            _this.wallet_fail_code.wallet_fail_code = val;


            _this
                .$post('/cutfail/cutWallet', _this.wallet_fail_code)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.failLists();

                 
                })

        },
        cancelCutWallet(val) {
            _this.wallet_fail_code.wallet_fail_code = val;


            _this
                .$post('/cutfail/cancelCutWallet', _this.wallet_fail_code)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.failLists();

                 
                })

        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.failLists();
        },
        searchFailLists() {
            _this.search_data.page = 1;
            _this.failLists();
        },
        failLists() {
            
            _this
                .$post('/cutfail/failLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                   
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>